export default ({ request }) => ({
  customerProofingListApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/list',
      method: 'POST',
      data,
    })
  },
  customerProofingDetailApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/detail',
      method: 'POST',
      data,
    })
  },
  customerProofingSaveApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/save',
      method: 'POST',
      data,
    })
  },
  customerProofingDelApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/del',
      method: 'POST',
      data,
    })
  },
  customerProofingConfirmApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/confirm',
      method: 'POST',
      data,
    })
  },
  customerProofingImageListApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/image/list',
      method: 'POST',
      data,
    })
  },
  customerProofingImageUploadApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/image/upload',
      method: 'POST',
      data,
    })
  },
  customerProofingImageDelApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/image/del',
      method: 'POST',
      data,
    })
  },
  customerProofingDocListApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/doc/list',
      method: 'POST',
      data,
    })
  },
  customerProofingDocUploadApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/doc/upload',
      method: 'POST',
      data,
    })
  },
  customerProofingDocUpdateApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/doc/update',
      method: 'POST',
      data,
    })
  },
  customerProofingDocDelApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/doc/del',
      method: 'POST',
      data,
    })
  },
  customerProofingFabricListApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/fabric/list',
      method: 'post',
      data,
    })
  },
  customerProofingFabricDetailApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/fabric/detail',
      method: 'post',
      data,
    })
  },
  customerProofingFabricBatchSaveApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/fabric/batch/save',
      method: 'post',
      data,
    })
  },
  customerProofingSampleListApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/sample/list',
      method: 'post',
      data,
    })
  },
  customerProofingSampleDetailApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/sample/detail',
      method: 'post',
      data,
    })
  },
  customerProofingSampleSaveApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/sample/save',
      method: 'post',
      data,
    })
  },
  customerProofingSampleDelApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/sample/del',
      method: 'post',
      data,
    })
  },
  customerProofingSampleImgApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/sample/img',
      method: 'post',
      data,
    })
  },

  customerProofingSampleDetailListApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/sample/detail/list',
      method: 'post',
      data,
    })
  },
  customerProofingSampleDetailDetailApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/sample/detail/detail',
      method: 'post',
      data,
    })
  },
  customerProofingSampleDetailSaveApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/sample/detail/save',
      method: 'post',
      data,
    })
  },
  customerProofingSampleDetailDelApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/sample/detail/del',
      method: 'post',
      data,
    })
  },
  customerProofingSampleDetailImgApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/sample/detail/img',
      method: 'post',
      data,
    })
  },
  customerProofingSampleDetailFabricListApi(data) {
    return request({
      url: '/digitalCenter/customer/proofing/sample/detail/fabric/list',
      method: 'post',
      data,
    })
  },
  customerProofingSampleDetailFabricPositionApi(data) {
    return request({
      url:
        '/digitalCenter/customer/proofing/sample/detail/fabric/fabric/position',
      method: 'post',
      data,
    })
  },
})
